import common from "../common";
import Scene from "./Scene";
import Text from "../ui/Text";

export default class VersusScene extends Scene {
    constructor(playerData, enemyData)
    {
        super('VersusScene');

        this.playerData = playerData;
        this.enemyData = enemyData;

        this.spines = [];
    }

    init()
    {
        super.init('bg');

        var vsText = new Text(common.text.translate('versus'), {
            font: 100 + "px Lalezar56",
            align: "center"
        });
        vsText.y = 400;
        vsText.x = common.STAGE_HALF_WIDTH;
        vsText.anchor.set(0.5);
        vsText.scale.set(0);
        this.addChild(vsText);

        var tl = new TimelineMax({delay:1});

        var count = 0;
        var characters = [this.playerData, this.enemyData];

        var foodAssets = common.config.weapons.weapons.basic.projectiles[0].images.slice();

        for(var i in characters)
        {
            var spineData = P3.assets.spineData(characters[i].spine + '_big');
            let spine = new PIXI.spine.Spine(spineData);
            spine.scale.set(0.8);
            spine.y = common.STAGE_HEIGHT + 30;
            spine.visible = false;
            spine.skeleton.setSlotsToSetupPose();
            spine.skeleton.setToSetupPose();
            spine.autoUpdate = false;

            if(characters[i].name === '???') spine.tint = 0x000000;

            P3.utils.delay(count == 0 ? 0.1 : 0.4, () => {
                spine.state.setAnimation(0, 'body_idle_fight', true);
                spine.state.setAnimation(1, 'legs_idle_fight', true);
            });

            if(characters[i].skin)
            {
                spine.skeleton.setSkin(spine.spineData.findSkin(characters[i].skin));
            }

            this.spines.push(spine);
            this.addChild(spine);

            var foodIndex = Math.floor(Math.random() * foodAssets.length);
            spine.foodImage = common.display.sprite({asset:common.config.weapons.images[foodAssets[foodIndex]].throw, anchorX:0.5, anchorY:1, scale:0.8, parent:this});
            spine.foodPoint = spine.skeleton.findBone('food_point');
            foodAssets.splice(foodIndex, 1);

            let charText = new Text(common.text.restrictText(common.text.translate(characters[i].name), 19, 10), {
                font: 70 + "px Lalezar48",
                align: "center"
            });
            charText.y = 150;
            charText.anchor.set(0.5);
            charText.scale.set(0);
            this.addChild(charText);

            var targetX;
            var delay = 0;
            if(count == 0)
            {
                spine.x = 0;
                targetX = common.STAGE_HALF_WIDTH - 250;
                charText.x = common.STAGE_HALF_WIDTH - 250;
            }
            else
            {
                spine.scale.x = -spine.scale.x;
                spine.x = common.STAGE_WIDTH;
                targetX = common.STAGE_HALF_WIDTH + 250;
                charText.x = common.STAGE_HALF_WIDTH + 250;
                delay = 0.2;
            }

            tl.to(spine, .5, {delay:delay, x:targetX, ease:Expo.easeOut, onStart:() => {
                spine.visible = true;
                common.audio.playSound(['sfx_throw_heavy_00', 'sfx_throw_light_00', 'sfx_throw_light_01', 'sfx_throw_light_02', 'sfx_throw_mid_00', 'sfx_throw_v_light_00', 'sfx_throw_v_light_01']);
                TweenMax.to(charText.scale, 0.5, {x:1, y:1, ease:Expo.easeOut});
            }});

            if(count == 0)
            {
                tl.to(vsText.scale, .5, {x:1, y:1, ease:Expo.easeOut});
            }

            count++;
        }

        var recordHolder = common.display.container({x:common.STAGE_HALF_WIDTH, y:common.STAGE_HEIGHT*1.5, scale:0.5, parent:this});
        TweenMax.to(recordHolder, 0.5, {delay:3, y:common.STAGE_HEIGHT - 100, ease:Expo.easeOut});

        var starPositions = [{x:-160, y:-80}, {x:0, y:-120}, {x:160, y:-80}];
        var recordData = common.saveData.getTopScore(common.currentBout);
        for(var i = 0; i < 3; i++)
        {
            common.display.sprite({asset:'star_' + (i < recordData.stars ? 'on' : 'off'), x:starPositions[i].x, y:starPositions[i].y, anchor:0.5, parent:recordHolder});
        }
        var recordPanel = common.display.sprite({asset:'panel_team', anchor:0.5, parent:recordHolder});

        var recordTextHolder = common.display.container({parent:recordPanel});
        var trophy = common.display.sprite({asset:'icon_trophy', anchorY:0.5, parent:recordTextHolder});
        var recordText = new Text(String(recordData.score), {
            font: 80 + "px Lalezar48",
            align: "center"
        });
        recordText.x = trophy.width + 5;
        recordText.y = -15;
        recordText.anchor.set(0, 0.5);
        recordTextHolder.addChild(recordText);

        recordTextHolder.x -= recordTextHolder.width/2;

        P3.utils.delay(5, () => {
            this.signals.next.dispatch();
        });

        common.audio.playSound('music_pause_loop', this.audioLoopParams);
    }

    destroy()
    {
        common.audio.stopSound('music_pause_loop');
        super.destroy();
    }

    update()
    {
        super.update();

        for(var i in this.spines)
        {
            this.spines[i].update(P3.Ticker.dt * common.timeStretch);
            this.spines[i].foodImage.x = this.spines[i].x + this.spines[i].foodPoint.worldX * this.spines[i].scale.x;
            this.spines[i].foodImage.y = this.spines[i].y + this.spines[i].foodPoint.worldY * this.spines[i].scale.y;
        }
    }

    resize()
    {
        super.resize();
    }
}